// Хелпери з legacy-бандла (news.js), яких потребують js/inc/*.js (напр. hint.js)
// на нових сторінках, де news.js не вантажиться.
if (typeof window.htmlenc !== 'function') {
	window.htmlenc = function (s) {
		return String(s == null ? '' : s).replace(/</g, '&lt;').replace(/>/g, '&gt;');
	};
}
if (typeof window.is_mobile !== 'function') {
	window.is_mobile = function () {
		return ($(window).width() <= 480) || $('body').hasClass('mobile');
	};
}

(function(factory){
	if (typeof define === 'function' && define.amd) {
		define(['jquery'], factory);
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('jquery'));
	} else {
		factory(window.jQuery);
	}
})(function($){
	'use strict';
	if (!$) return;

	function clamp(v, a, b){ return Math.max(a, Math.min(v, b)); }

	// Fast JS-driven horizontal scroll animation (duration in ms)
	function smoothScrollToX(el, toLeft, duration){
		const start = el.scrollLeft;
		const dist  = toLeft - start;
		if (Math.abs(dist) < 1 || duration <= 0){
			el.scrollLeft = toLeft;
			return;
		}
		const t0 = performance.now();
		const ease = (t)=> t<.5 ? 2*t*t : -1+(4-2*t)*t; // easeInOutQuad
		function tick(now){
			const p = Math.min(1, (now - t0)/duration);
			el.scrollLeft = start + dist * ease(p);
			if (p < 1) requestAnimationFrame(tick);
		}
		requestAnimationFrame(tick);
	}

	function initCarousel($root){
		const $track = $root.find('.carousel__cards');
		const $items = $track.find('.carousel__item');
		const $prev  = $root.find('.carousel__btn-prev');
		const $next  = $root.find('.carousel__btn-next');
		const $steps = $root.find('.carousel__steps .carousel__step');

		if (!$track.length || !$items.length) return;

		const track = $track.get(0);
		const AUTOPLAY_MS = 10000; // 10s
		const IGNORE_SCROLL_MS = 400;

		// State
		let autoplayT = null;
		let afterScrollSyncT = null;
		let activeIndex = 0;
		let ignoreScrollUntil = 0;
		let raf = 0;

		// Helpers
		const indexNearCenter = () => {
			const r = track.getBoundingClientRect();
			const center = r.left + r.width/2;
			let best = 0, bestDist = Infinity;
			$items.each(function(i){
				const ri = this.getBoundingClientRect();
				const ci = ri.left + ri.width/2;
				const d = Math.abs(ci - center);
				if (d < bestDist){ best = i; bestDist = d; }
			});
			return best;
		};

		const leftForCenter = (el) => {
			const w = el.offsetWidth;
			const left = el.offsetLeft - (track.clientWidth - w)/2;
			const maxL = track.scrollWidth - track.clientWidth;
			return Math.max(0, Math.min(left, Math.max(0, maxL)));
		};

		function setButtonsForIndex(i){
			if ($prev.length) $prev.prop('disabled', i <= 0);
			if ($next.length) $next.prop('disabled', i >= $items.length - 1);
		}

		function updateButtons(){
			const i = indexNearCenter();
			setButtonsForIndex(i);
		}

		function setCurrentClasses(index){
			$items.removeClass('carousel__item-active');
			$items.eq(index).addClass('carousel__item-active');

			$steps.removeClass('carousel__step-current');
			$steps.eq(index).addClass('carousel__step-current');

			activeIndex = index;
		}

		function resetOtherMarkers(current){
			$steps.each(function(i){
				if (i === current) return;
				const m = this.querySelector('.carousel__stepMarker');
				if (!m) return;
				m.style.transition = 'none';
				m.style.left = '-20px';
			});
		}

		// Double-rAF start to guarantee smooth transition on left
		function animateMarkerFor(index){
			const step = $steps.get(index);
			if (!step) return;
			const m = step.querySelector('.carousel__stepMarker');
			if (!m) return;

			// 1) lock current position without transition
			m.style.transition = 'none';
			const curLeft = getComputedStyle(m).left;
			m.style.left = (curLeft === 'auto' || curLeft === '') ? '-20px' : curLeft;

			// Force reflow
			// eslint-disable-next-line no-unused-expressions
			m.offsetHeight;

			// 2) next frame enable transition
			requestAnimationFrame(() => {
				m.style.transition = 'left var(--autoplay-ms, 10s) linear';
				// 3) next frame set destination
				requestAnimationFrame(() => {
					m.style.left = '0px';
				});
			});
		}

		function startAutoplay(fromIndex){
			clearTimeout(autoplayT);
			resetOtherMarkers(fromIndex);
			animateMarkerFor(fromIndex);
			autoplayT = setTimeout(() => {
				go(+1, /*fromAutoplay*/true);
			}, AUTOPLAY_MS);
		}

		function go(delta, fromAutoplay=false){
			const current = indexNearCenter();

			// Compute next index
			let idx;
			if (fromAutoplay) {
				idx = current + delta;
				if (idx > $items.length - 1) idx = 0;
				if (idx < 0) idx = $items.length - 1;
			} else {
				idx = Math.max(0, Math.min(current + delta, $items.length - 1));
			}

			const el  = $items.get(idx);

			// Wrap detection
			const isForwardWrap = fromAutoplay && current === $items.length - 1 && idx === 0;
			const isBackwardManualWrap = !fromAutoplay && current === 0 && idx === $items.length - 1;

			if (isForwardWrap) {
				// LAST -> FIRST (autoplay): instant horizontal jump on the track only
				ignoreScrollUntil = performance.now() + 50;
				track.scrollTo({ left: 0, behavior: 'instant' });
				setCurrentClasses(0);
				setButtonsForIndex(0);
				startAutoplay(0);
				return;
			}

			if (isBackwardManualWrap) {
				// FIRST -> LAST (manual prev): fast animated horizontal scroll
				const lastEl = $items.get($items.length - 1);
				const toLeft = leftForCenter(lastEl);
				ignoreScrollUntil = performance.now() + IGNORE_SCROLL_MS;
				smoothScrollToX(track, toLeft, 250);   // ~0.25s quick scroll
				setCurrentClasses($items.length - 1);
				setButtonsForIndex($items.length - 1);
				startAutoplay($items.length - 1);
				return;
			}

			// Regular move — only horizontal track scroll
			const toLeft = leftForCenter(el);
			ignoreScrollUntil = performance.now() + IGNORE_SCROLL_MS;
			// Prefer JS animation for consistent feel across browsers
			smoothScrollToX(track, toLeft, 250);

			setCurrentClasses(idx);
			setButtonsForIndex(idx);
			requestAnimationFrame(updateButtons);

			startAutoplay(idx);
			setTimeout(updateButtons, 200);
		}

		// Events
		$prev.on('pointerdown', (e) => { e.preventDefault(); go(-1); });
		$next.on('pointerdown', (e) => { e.preventDefault(); go(1); });

		// Keyboard: prevent page from scrolling on arrows by handling on the track
		if (!$track.attr('tabindex')) $track.attr('tabindex','0');
		$track.on('keydown', (e) => {
			if (e.key === 'ArrowLeft')  { e.preventDefault(); go(-1); }
			if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
		});

		// Debounced sync after user scrolls the track
		$track.on('scroll', () => {
			if (performance.now() < ignoreScrollUntil) return;
			if (raf) return;
			raf = requestAnimationFrame(() => {
				raf = 0;
				updateButtons();
				clearTimeout(afterScrollSyncT);
				afterScrollSyncT = setTimeout(() => {
					const i = indexNearCenter();
					if (i !== activeIndex) {
						setCurrentClasses(i);
						startAutoplay(i);
					}
				}, 120);
			});
		});

		// Pause/resume timers with page visibility
		document.addEventListener('visibilitychange', () => {
			if (document.hidden) {
				clearTimeout(autoplayT);
			} else {
				const i = indexNearCenter();
				setCurrentClasses(i);
				startAutoplay(i);
			}
		});

		// Init
		updateButtons();
		setCurrentClasses(0);
		setButtonsForIndex(0);
		startAutoplay(0);
	}

	// Auto-init all carousels on DOM ready
	$(function(){
		$('.carousel').each(function(){ initCarousel($(this)); });
	});
});

// ==== Manual carousel (no overflow, no viewport) — ALIGN TO CONTROLS LEFT ====
(function ($) {
	if (!$) return;

	function getTranslateX(el) {
		const t = getComputedStyle(el).transform;
		if (!t || t === 'none') return 0;
		if (t.startsWith('matrix3d')) return parseFloat(t.split(',')[12]) || 0;
		return parseFloat(t.split(',')[4]) || 0;
	}

	// rAF-анімація translateX з токеном для коректного скасування
	function animateTranslate(el, toX, duration, easeFn) {
		const fromX = getTranslateX(el);
		const ease = easeFn || (t => (t < .5 ? 2*t*t : -1 + (4 - 2*t)*t));
		const start = performance.now();
		const token = (el._animToken || 0) + 1;
		el._animToken = token;

		function frame(now){
			if (el._animToken !== token) return;
			const p = Math.min(1, (now - start)/duration);
			const e = ease(p);
			el.style.transform = `translateX(${fromX + (toX - fromX)*e}px)`;
			if (p < 1) el._animId = requestAnimationFrame(frame);
			else el._animId = null;
		}
		if (duration <= 0){ el.style.transform = `translateX(${toX}px)`; return; }
		if (el._animId) cancelAnimationFrame(el._animId);
		el._animId = requestAnimationFrame(frame);
	}

	function initManualCarousel($root){
		const $controls = $root.find('.carousel__controls');
		const $track    = $root.find('.carousel__content');   // без в’юпорту
		const $items    = $track.find('.carousel__item');
		if (!$controls.length || !$track.length || !$items.length) return;

		const $btns = $controls.find('button, .btn');
		const $prev = $btns.eq(0);
		const $next = $btns.eq(1);

		const LOOP = $root.data('loop') !== false; // дефолт: true
		const DUR  = 420;

		let index = 0;
		let busy  = false;
		let baseLeft = 0; // ліва координата треку БЕЗ трансформації

		// чесно виміряти baseLeft (тимчасово вимикаємо transform)
		function measureBaseLeft(){
			const el = $track.get(0);
			const prev = el.style.transform;
			el.style.transform = 'translateX(0px)';
			baseLeft = $track.get(0).getBoundingClientRect().left;
			el.style.transform = prev;
		}

		// таргетний X: лівий край item вирівнюємо з лівим краєм controls
		function xForIndex(i){
			const ctrlLeft = $controls.get(0).getBoundingClientRect().left;
			const itemLeftInTrack = $items.get(i).offsetLeft; // від початку .carousel__content
			// скільки треба зсунути трек: -(позиція айтема - (ctrlLeft - baseLeft))
			return -(itemLeftInTrack - (ctrlLeft - baseLeft));
		}

		function setButtons(){
			if (!LOOP){
				$prev.prop('disabled', index <= 0);
				$next.prop('disabled', index >= $items.length - 1);
			} else {
				$prev.prop('disabled', false);
				$next.prop('disabled', false);
			}
		}

		async function goTo(to){
			if (busy) return;
			let i = to;
			if (!LOOP){
				i = Math.max(0, Math.min(i, $items.length - 1));
			} else {
				if (i < 0) i = $items.length - 1;
				if (i > $items.length - 1) i = 0;
			}
			if (i === index) return;

			// перед рухом — актуалізуємо baseLeft (але без миготіння)
			measureBaseLeft();
			const targetX = xForIndex(i);
			busy = true;
			animateTranslate($track.get(0), targetX, DUR);
			setTimeout(()=>{ busy = false; }, DUR + 16);

			index = i;
			setButtons();
		}

		// події
		$prev.on('pointerdown', (e)=>{ e.preventDefault(); goTo(index - 1); });
		$next.on('pointerdown', (e)=>{ e.preventDefault(); goTo(index + 1); });

		// клавіатура по треку
		if (!$track.attr('tabindex')) $track.attr('tabindex','0');
		$track.on('keydown', (e)=>{
			if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(index - 1); }
			if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
		});

		// ресайз: переміряти baseLeft і миттєво виставити позицію поточного
		let rAF = 0;
		$(window).on('resize', ()=>{
			if (rAF) return;
			rAF = requestAnimationFrame(()=>{
				rAF = 0;
				measureBaseLeft();
				$track.get(0).style.transform = `translateX(${xForIndex(index)}px)`;
			});
		});

		// ініт
		measureBaseLeft();
		$track.get(0).style.transform = `translateX(${xForIndex(0)}px)`;
		index = 0;
		setButtons();
	}

	$(function(){
		$('.carousel-manual').each(function(){ initManualCarousel($(this)); });
	});
})(window.jQuery);
$(function () {
	if (typeof RiveManager != 'undefined') {
		RiveManager.scan();
		if ($(window).width() < 640) {
			const debouncedRiveScan = debmain(() => {
				RiveManager.scan();
			}, 300);
			$(window).on('resize', debouncedRiveScan);
		}
	}
	let priceData = {};
	let currentRate    = 1;
	let currentSymbol  = '$';
	let currentUserVal = 1;
	let currentPeriod  = 'yearly';
	var updateLFPrices = function () {};
	// fmtUah — у спільній області, бо її кличе й калькулятор команди нижче.
	// Блокова function-декларація всередині if при мінімізації (swc) стає локальною змінною з іншим ім'ям,
	// і виклик з калькулятора падав із "fmtUah is not defined" у зібраному main.js
	var fmtUah = function (val) {
		// "дрібні" валюти (KZT: ~445 за $) завжди цілими; решта — цілими лише для великих команд
		if (currentRate !== 1 && (currentUserVal > 99 || currentRate >= 100)) val = Math.round(val);
		return formatPrice(val);
	};
	let priceEl = $('#main').find('.planAndPrices');
	if (priceEl.length > 0) {
		let discount = 1 + parseInt(priceEl.find('.sw .label__fire__text').first().text()) / 100;
		priceEl.find('.planAndPrices__plan').each(function() {
			const match = $(this).attr('class').match(/planAndPrices__plan-(\w+)/);
			if (match && match[1] !== 'free') {
				let priceMonthly = parseFloat($(this).find('.digit .price_digit-monthly').text());
				let priceYearly = parseFloat($(this).find('.digit .price_digit-yearly').text());
				priceData[match[1]] = {
					'monthly': priceMonthly,
					'yearly': priceYearly,
					'discount': discount
				}
			}
		});
	}

	let calcRow = $('#main .planAndPrices__calc');
	if (calcRow.length > 0) {
		let calcInp = $('#teamSize');

		calcRow.find('button').on('click', function () {
			let btnVal = parseInt($(this).find('span').text());
			calcInp.val(btnVal).trigger('input');
		});

		calcInp.on('input', function () {
			$(this).val($(this).val().replace(/\D/g, '').slice(0, 4)).removeClass('selected');
			let pInt = parseInt($(this).val());
			if (!pInt || pInt < 1) $(this).val(1);

			let userVal = parseInt($(this).val());
			currentUserVal = userVal;
			calcRow.find('button').each(function () {
				$(this).toggleClass('btn-semi-active', parseInt($(this).find('span').text()) === userVal);
			});

			$.each(priceData, function (planKey, plan) {
				let monthlyTotal = plan.monthly * userVal * currentRate;
				let yearlyTotal  = plan.yearly  * userVal * currentRate;

				let planEl = priceEl.find('.planAndPrices__plan-' + planKey);
				planEl.find('.digit .price_digit-calcMonthly').text(fmtUah(monthlyTotal));
				planEl.find('.digit .price_digit-calcYearly').text(fmtUah(yearlyTotal));

				let placeHolder = planEl.find('.planAndPrices__plan-seats');
				let placeText = placeHolder.attr('data-repl-text').replace('%s', userVal)
					+ ' ' + pluralForm(userVal, placeHolder.attr('data-repl-form'));
				placeHolder.text(placeText);
				let sumFull = monthlyTotal * 12;
				planEl.find('.numberStrike').text(fmtUah(sumFull));
				let sumDiff = sumFull - yearlyTotal;
				planEl.find('.savings span').text(currentSymbol + fmtUah(sumDiff));
				planEl.find('.plan-seats').text(userVal);
			});
			let freeplanEl = priceEl.find('.planAndPrices__plan-free');
			if (userVal>1) priceEl.addClass('price_calc'); else priceEl.removeClass('price_calc');
			if (userVal>5) freeplanEl.addClass('unavailable'); else freeplanEl.removeClass('unavailable');
			setTimeout(function (){$('#teamSize').blur();}, 1000);
		});
	}

	$('#teamSize').on('focus', function() {
		$(this).select().addClass('selected');
	});

	$(document).on('mouseenter focusin', '.clientReviews__preview', function () {
		const v = $(this).find('video').get(0)
		if (v && v.paused) v.play().catch(()=>{})
	});
	$(document).on('mouseleave focusout', '.clientReviews__preview', function () {
		const v = $(this).find('video').get(0)
		if (v) v.pause()
	});
	$(document).on('pointerup', '.clientReviews__preview', function () {
		if (matchMedia('(hover: none)').matches) {
			const v = $(this).find('video').get(0)
			if (!v) return
			if (v.paused) v.play().catch(()=>{})
			else v.pause()
		}
	});
	$(document).on('click', '.clientReviews__preview', function () {
		const url = $(this).attr('data-url');
		if (url) window.open(url, "_blank");
	});
	$(document).on('click', '[data-href]', function () {
		const url = $(this).attr('data-href');
		const modal = $(this).attr('data-modal');
		const targetSelf = $(this).attr('data-target') === 'self';
		if (url && !modal) window.open(url, targetSelf ? "_self" : "_blank");
	});
	const dataClickActions = {
		intercom: function () {
			if (window.WS_FA) {
				WS_FA.open('support');
			} else if (typeof Intercom === 'function') {
				Intercom('show');
			} else if (window.WS_FA_CONFIG && WS_FA_CONFIG.intercom) {
				// supportWidgets.js не підключений — вантажимо Intercom самі і одразу відкриваємо
				window.intercomSettings = { app_id: WS_FA_CONFIG.intercom.app_id, language_override: document.documentElement.lang || undefined };
				const q = function () { q.c(arguments); }; q.q = []; q.c = function (args) { q.q.push(args); };
				window.Intercom = q;
				const s = document.createElement('script');
				s.async = true;
				s.src = 'https://widget.intercom.io/widget/' + WS_FA_CONFIG.intercom.app_id;
				s.onload = function () { Intercom('boot', window.intercomSettings); Intercom('show'); };
				document.head.appendChild(s);
			}
		}
	};
	$(document).on('click', '[data-onclick]', function () {
		const action = $(this).attr('data-onclick');

		if (dataClickActions[action]) {
			dataClickActions[action]();
		}
	});
	$(document).on('click', '.footer__main-groupTitle', function() {
		$(this).toggleClass('footer__main-groupActive');
	});
	$(document).on('click', '.planAndPrices__toggle .sw', function(){
		let price = $('.planAndPrices__plan');
		let act = $(this).hasClass('sw_act');
		price.toggleClass('yearly', act);
		currentPeriod = act ? 'yearly' : 'monthly';
		updateLFPrices();
	});
	$(document).on('click', '.planAndPrices__plan-cta button, .tablePlanContainer-button button', function(){
		let plan_alias = $(this).attr('data-alias');
		reg_to_plan(plan_alias);
		return false;
	});
	$(document).on('click', '#mobMenu', function(){
		$('body').toggleClass('with_mob_menu');
		$('.mobile-open').removeClass('mobile-open');
	});
	$(document).on('click', '.mobile__menu__group-sub[data-target]', function(e){
		e.preventDefault();
		e.stopPropagation();
		let menuId = $(this).attr('data-target');
		let menuEl = $('#' + menuId);
		if (menuEl.length === 0) return;
		menuEl.addClass('mobile-open');
	});
	$('.menu__group-mobileHeader').on('click',function (){
		let menuEl = $(this).closest('.menu');
		if (menuEl.length === 0) return;
		menuEl.addClass('mobile-closing');
		menuEl.one('animationend', function() {
			menuEl.removeClass('mobile-open mobile-closing');
		});
	});

	if (priceEl.length > 0) {
		// двознакові символи (zł, Kč) ширші за 24px-відступ цифр: міряємо символ і виставляємо --price-symbol-w
		function setSymbolOffset($digits) {
			$digits.each(function () {
				var sym = this.querySelector('span:first-child');
				if (currentSymbol.length > 1 && sym) {
					this.style.setProperty('--price-symbol-w', Math.ceil(sym.getBoundingClientRect().width + 8) + 'px');
				} else {
					this.style.removeProperty('--price-symbol-w');
				}
			});
		}

		updateLFPrices = function () {
			// .lf-stickyThead — клон шапки таблиці на ≤1024px (longFeatures-hscroll.js), оригінальний thead тоді схований
			var $lf = $('#longFeatures, .lf-stickyThead');
			if (!$lf.length) return;
			$lf.find('.digit > span:first-child').text(currentSymbol);
			setSymbolOffset($lf.find('.digit'));
			$lf.find('.price_digit[data-price-monthly]').each(function () {
				var base = (currentPeriod === 'yearly')
					? parseFloat($(this).data('price-yearly'))
					: parseFloat($(this).data('price-monthly'));
				$(this).text(fmtUah(base * currentRate));
			});
		};

		function setCurrency(currency) {
			// currency — код з data-currency пункту меню (USD, UAH, EUR, PLN, CZK, KZT); курси — WS_RATES з футера
			var item = $('#currencySwitch .menu__item[data-currency="' + currency + '"]').first();
			if (!item.length) return;
			currentRate   = (typeof WS_RATES !== 'undefined' && WS_RATES[currency]) ? WS_RATES[currency] : 1;
			currentSymbol = item.attr('data-symbol') || '$';

			$('[data-menu-container="currencySwitch"] span').first().text(currentSymbol + ' ' + currency);

			$('#currencySwitch .menu__item').each(function () {
				$(this).toggleClass('menu__item-active', $(this).attr('data-currency') === currency);
			});

			priceEl.find('.digit > span:first-child').text(currentSymbol);
			priceEl.find('.superBlock-fullprice .s').text(currentSymbol);
			setSymbolOffset(priceEl.find('.digit'));

			$.each(priceData, function (planKey, plan) {
				var planEl  = priceEl.find('.planAndPrices__plan-' + planKey);
				var monthly = plan.monthly * currentRate;
				var yearly  = plan.yearly  * currentRate;

				planEl.find('.price_digit-monthly').text(fmtUah(monthly));
				planEl.find('.price_digit-yearly').text(fmtUah(yearly));

				planEl.find('.text-monthly span:first-child').text(currentSymbol + fmtUah(monthly));
				planEl.find('.text-yearly span:first-child').text(currentSymbol + fmtUah(plan.yearly / 12 * currentRate));

				planEl.find('.numberStrike').text(fmtUah(monthly * 12));
				planEl.find('.savings span').text(currentSymbol + fmtUah(monthly * 12 - yearly));
			});

			$('#teamSize').trigger('input');
			updateLFPrices();

			if (typeof App !== 'undefined' && App.menu) App.menu.hide();
		}

		$('#menuContainer').on('click', '#currencySwitch .menu__item', function () {
			setCurrency($(this).attr('data-currency'));
		});

		// ціни в розмітці в USD; якщо валюта за замовчуванням інша (KZ/CZ/PL), одразу перераховуємо
		var defaultCurrency = $('#currencySwitch .menu__item-active').attr('data-currency');
		if (defaultCurrency && defaultCurrency !== 'USD') setCurrency(defaultCurrency);
	}
});

$(function(){
	const $w=$(window), $el=$('body');
	const t=8;
	function u(){ $el.toggleClass('is-scrolled', $w.scrollTop()>t); }
	u(); $w.on('scroll resize', u);

	$('.reg_btn_new').on('click', function(){
		App.auth.show();
	});
	$('.auth_btn_new, .header__logged').on('click', function(){
		App.auth.show('logged');
	});
});

function lang_sw(lang_pref) {
	if (!lang_pref) return;

	const { origin, protocol, host, pathname, search, hash } = window.location;
	const base = origin || (protocol + '//' + host);
	const path = pathname || '/';

	const segs = path.split('/').filter(Boolean);

	if (segs.length && /^[a-z]{2}(?:-[a-z]{2})?$/i.test(segs[0])) {
		segs.shift();
	}

	const cleanLang = String(lang_pref).replace(/^\/+|\/+$/g, '');
	const tail = segs.join('/');

	const lastSeg = segs.length ? segs[segs.length - 1] : '';
	const isFile = /\.[a-z0-9]{1,8}$/i.test(lastSeg);

	let newPath = '/' + cleanLang + '/';
	if (tail) {
		newPath += tail;
		if (!isFile && !newPath.endsWith('/')) newPath += '/';
	}

	window.location.href = base + newPath + (search || '') + (hash || '');
}

function reg_to_plan(alias) {
	if (alias) {
		App.auth.plan_type = alias;
		App.auth.show();
	}
}

function debmain(fn, delay) {
	let timer;
	return function () {
		let context = this;
		let args = arguments;

		clearTimeout(timer);
		timer = setTimeout(function () {
			fn.apply(context, args);
		}, delay);
	};
}
function formatPrice(val) {
	val = parseFloat(val);
	val = val % 1 === 0 ? parseInt(val) : parseFloat(val.toFixed(2));
	return val.toLocaleString('en-US');
}
function pluralForm(num, text) {
	const forms = text.split('|');
	if (forms.length !== 3) return text;

	num = Math.abs(num);
	const lastDigit    = num % 10;
	const lastTwoDigits = num % 100;

	if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return forms[2];
	if (lastDigit === 1)                             return forms[0];
	if (lastDigit >= 2 && lastDigit <= 4)            return forms[1];
	return forms[2];
}
$(function(){
	$('.sw').on('click', function(){
		$(this).toggleClass('sw_act');
	});
});

$(function(){
	const $overlay = $('#searchOverlay');
	if (!$overlay.length) return;

	let searchOpen = false;

	function openSearch() {
		if (searchOpen) return;
		searchOpen = true;
		document.documentElement.style.scrollbarGutter = 'stable';
		$('[data-search-container]').css('z-index', parseInt($overlay.css('z-index') || 0) + 1);
		$overlay.css({ transition: 'opacity 0.25s', opacity: 1, 'pointer-events': 'auto' });
		$('body').addClass('no-scroll');
		$('.intercom-lightweight-app, .rngst_phone_button, .fa').css('display', 'none');
	}

	function closeSearch() {
		if (!searchOpen) return;
		searchOpen = false;
		$overlay.css({ transition: 'opacity 0.25s', opacity: 0, 'pointer-events': 'none' });
		$('[data-search-input], [data-search-visible]').trigger('blur');
		$('body').removeClass('no-scroll');
		document.documentElement.style.scrollbarGutter = '';
		$('.intercom-lightweight-app, .rngst_phone_button, .fa').css('display', '');
		setTimeout(function(){
			$('[data-search-container]').css('z-index', '');
		}, 250);
	}

	$(document).on('click', '[data-search-btn]', function(){
		const $visible = $('[data-search-visible]').first();
		($visible.length ? $visible : $('[data-search-input]').first()).trigger('focus');
	});

	$(document).on('focus', '[data-search-input], [data-search-visible]', function(){
		openSearch();
	});

	$overlay.on('click', function(e){
		if (e.target === this) closeSearch();
	});

	$(document).on('keydown', function(e){
		if (e.key === 'Escape') closeSearch();
	});
});

function initTypoImageZoom() {
	$('.typo img').each(function () {
		if ($(this).data('zoom_init')) return;
		$(this).data('zoom_init', true).css('cursor', 'zoom-in');
	});

	$('.typo img').off('click.zoom').on('click.zoom', function (e) {
		if (window.innerWidth < 800) return;
		e.preventDefault();

		let src = $(this).attr('src');

		let $source = $(this).closest('picture').find('source[type="image/avif"]');
		if ($source.length) {
			let parts = $source.attr('srcset').split(',').map(function (s) { return s.trim(); });
			let best  = parts.find(function (s) { return s.endsWith('2x'); }) || parts.find(function (s) { return s.endsWith('1x'); });
			if (best) src = best.split(' ')[0];
		} else {
			let srcset = $(this).attr('srcset');
			if (srcset) {
				let parts2 = srcset.split(',').map(function (s) { return s.trim(); });
				let x2     = parts2.find(function (s) { return s.endsWith('2x'); });
				if (x2) src = x2.split(' ')[0];
			}
		}

		App.modal.show(src, { width: false, fullscreen_threshold: false, skip_auto_width: true, load_type: 'image' });
	});
}

$(document).ready(function(){
	function onElementAdded(element) {
		let iframe = $(element).find('iframe').get(0);
		if (iframe) {
			let iframeHead = $(iframe.contentWindow.document).find("head");
			iframeHead.append('<link rel="stylesheet" href="/assets/css/vendor/ringostat.css" />');
			setTimeout(function (){ $('#wrapper_id').css({'opacity': 1});}, 300);
		}
	}

	if ( $('body').hasClass('logged') && typeof Intercom !== 'undefined' ) {
		Intercom('update', {
			"hide_default_launcher": true
		});
	}

	initTypoImageZoom();

	$('[data-copy-url]').on('click', function () {
		let $btn  = $(this);
		let label = $btn.data('copy-label');
		let $span = $btn.find('span');
		let orig  = $span.text();
		navigator.clipboard.writeText(window.location.href).then(function () {
			$span.text(label);
			setTimeout(function () { $span.text(orig); }, 2000);
		});
	});

	let observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			mutation.addedNodes.forEach(function(node) {
				if (node.nodeType === 1 && node.id === 'wrapper_id') {
					onElementAdded(node);
				}
				if (node.nodeType === 1 && node.classList.contains('rngst_phone_button')) {
					let now = new Date();
					let hour = now.getHours();
					//if (hour < 10 || hour > 17 || window.location.href.includes('support.html')) $(node).hide();
				}
			});
		});
	});

	let config = { childList: true, subtree: true };

	observer.observe(document.body, config);
});

// ---------------- Лічильник maxlength (.ws-limit) ----------------
// Обгортці .ws-limit навколо input/textarea з maxlength додається
// лічильник «N / max» у правому нижньому куті поля
$(function () {

	function init($wrap) {
		if ($wrap.data('wsLimit')) return;
		var $f = $wrap.find('input[maxlength], textarea[maxlength]').first();
		if (!$f.length) return;
		$wrap.data('wsLimit', true);
		$('<span class="ws-limit__counter"><span class="ws-limit__count"></span><span>/</span><span>'
			+ $f.attr('maxlength') + '</span></span>').appendTo($wrap);
		update($f);
	}

	// резервуємо місце під лічильник, щоб текст на нього не налазив:
	// в input — праворуч, у textarea — знизу
	function reserve($wrap, $f) {
		var $c = $wrap.find('.ws-limit__counter');
		if (!$c.length || !$c.outerWidth()) return;
		if ($f.is('textarea')) {
			$f.css('padding-bottom', ($c.outerHeight() + 16) + 'px');
		} else {
			$f.css('padding-right', ($c.outerWidth() + 28) + 'px');
		}
	}

	function update($f) {
		var $wrap = $f.closest('.ws-limit');
		$wrap.find('.ws-limit__count').text(String($f.val() || '').length);
		reserve($wrap, $f);
	}

	window.App = window.App || {};
	App.initLimits = function (ctx) {
		$(ctx || document).find('.ws-limit').each(function () { init($(this)); });
	};

	App.initLimits();

	$(document).on('input change', '.ws-limit input[maxlength], .ws-limit textarea[maxlength]', function () {
		var $f = $(this);
		init($f.closest('.ws-limit'));
		update($f);
	});
});
